import React, { useEffect, useState } from 'react'

import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Switch } from '@headlessui/react'
import Select from 'react-select';
import { useNavigate } from "react-router-dom";

import Loader from '../../../utils/Loader';

const ActivePlanEdit = ({ close, activePlan }) => {

    const [formData, setFormData] = useState({
        plan_id: activePlan.plan_id,
        group_id: activePlan.group_id,
        start_date: activePlan.start_date,
        end_date: activePlan.end_date,
        status: activePlan.status,
        customer_ids: activePlan.customers.map((item) => (
            item.id
        )),
    });


    const [plan, SetPlan] = useState([])
    const [group, Setgroup] = useState([])
    const [enabled, setEnabled] = useState(false)
    const [validation, setValidation] = useState([])
    const [customerId, setCustomerId] = useState([])
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(true)
     const navigate = useNavigate();


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const fetchData = async () => {
        setLoading(true)
        try {
            const token = localStorage.getItem("token");
            const headers = { Authorization: `Bearer ${token}` };

            const [plansRes, groupsRes, customersRes,activePlanDetails] = await Promise.all([
                axios.get("public/api/plans/list", { headers }),
                axios.get("public/api/groups/list", { headers }),
                axios.get("public/api/customers/filter/list", { headers }),
                axios.get(`public/api/active/plans/${activePlan.id}`, { headers }),
            ]);

            


            setCustomerId(customersRes?.data?.data);
            SetPlan(plansRes.data);
            Setgroup(groupsRes.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm");
            }

            setError(error.response.data.messaage || " Please check your internet connection and try again.")
        }finally{
            setLoading(false)
        }
    };


    useEffect(() => {
        fetchData()
    }, [])


    const options = customerId?.map((item) => ({
        label: item.name,
        value: item.id
    }));

    const handleChangeData = (selectedOption) => {
        const selectedIds = selectedOption.map((option) => option.value);
        // setSelectCustomer(selectedOption);
        setFormData((prevState) => ({
            ...prevState,
            customer_ids: selectedIds,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const token = localStorage.getItem("token");

            const response = await axios.put(
                `public/api/active/plans/${activePlan.id}`,
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );
          
            toast.success(response.data.message);
            close()

        } catch (error) {
             if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm");
            }

            toast.error(error.response.data.messaage || "Please check your internet connection and try again.");
            
        }finally{
           setLoading(false) 
        }
    };


      if (loading) {
        return (
          <Loader />
        )
      }
    


    return (
        <div className='p-6'>
            {/* <div className="col-span-3 bg-indigo-400  p-6">
                <div className="max-w-7xl mx-auto md:px-8 flex justify-between items-center">
                    <dt className="text-xl text-white font-medium leading-6">EDIT ACTIVE PLAN</dt>
                    <button
                        onClick={close}
                        className="text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="white"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            ></path>
                        </svg>
                    </button>
                </div>
            </div> */}

            {/* <div className="max-w-7xl  p-6 bg-gray-100">
                <div className="md:grid md:gap-6">
                    <div className=" md:col-span-2">
                        <form
                            onSubmit={handleSubmit}
                        >
                            <div className="shadow overflow-hidden sm:rounded-md">
                                <div className="px-4 py-5 bg-white sm:p-6">
                                    <div className="grid grid-cols-6 gap-6">
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <label
                                                htmlFor="customer_ids"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                Customer Name
                                            </label>
                                            <div className="mt-2">
                                                <Select
                                                    label="Customer Name"
                                                    name="customer_ids"
                                                    options={options}
                                                    onChange={handleChangeData}
                                                    value={options?.filter(opt => formData.customer_ids?.includes(opt.value))} // convert back for display
                                                    isSearchable
                                                    isMulti
                                                />
                                            </div>

                                        </div>

                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <label
                                                htmlFor="plan_id"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                Plan
                                            </label>
                                            <div className="mt-2">
                                                <select
                                                    id="plan_id"
                                                    name="plan_id"
                                                    value={formData.plan_id}
                                                    onChange={handleChange}
                                                    autoComplete="plan_id"
                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                >
                                                    <option value={""}>Select Plan</option>
                                                    {plan?.map((type) => (
                                                        <option key={type.id} value={type.id}>
                                                            {type.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>


                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <label
                                                htmlFor="group_id"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                Group
                                            </label>
                                            <div className="mt-2">
                                                <select
                                                    id="group_id"
                                                    name="group_id"
                                                    value={formData.group_id}
                                                    onChange={handleChange}
                                                    autoComplete="group_id"
                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                >
                                                    <option value={""}>Select Group</option>

                                                    {group?.map((type) => (
                                                        <option key={type.id} value={type.id}>
                                                            {type.group_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <label
                                                htmlFor="amount"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                Start Date
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    id="start_date"
                                                    name="start_date"
                                                    type="date"
                                                    placeholder="Enter "
                                                    value={formData.start_date}
                                                    onChange={handleChange}
                                                    autoComplete="amount"
                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                />
                                                <p className="text-red-600 text-sm mt-1">
                                                    {validation.data?.email}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <label
                                                htmlFor="amount"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                End Date
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    id="end_date"
                                                    name="end_date"
                                                    type="date"
                                                    placeholder="Group Name"
                                                    value={formData.end_date}
                                                    onChange={handleChange}
                                                    autoComplete="amount"
                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                />
                                                <p className="text-red-600 text-sm mt-1">
                                                    {validation.data?.email}
                                                </p>
                                            </div>
                                        </div>



                                        <div className="col-span-6 sm:col-span-6 lg:col-span-3">
                                            <label
                                                htmlFor="status"
                                                className="block text-sm font-medium leading-6 text-gray-900"
                                            >
                                                Status
                                            </label>
                                            <div className="mt-2">
                                                <select
                                                    id="status"
                                                    name="status"
                                                    value={formData.status}
                                                    onChange={handleChange}
                                                    autoComplete="status"
                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                >
                                                    <option value={""}>Select Status</option>
                                                    <option value="active">active</option>
                                                    <option value="inactive">Inactive</option>
                                                </select>
                                            </div>
                                        </div>






                                    </div>
                                </div>
                                <div className="px-4 py-3 bg-white text-right sm:px-6">
                                    <button
                                        type="submit"
                                        className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div> */}
            <div className="flex items-center justify-end  w-full">
                <button
                    onClick={close}
                    className="text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="black"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                        ></path>
                    </svg>
                </button>
            </div>
            <div className='flex flex-col items-center mt-6  '>
                <div className="bg-blue-500 text-white p-3  rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" color="#ffffff" fill="none">
                        <path d="M7.99805 16H11.998M7.99805 11H15.998" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path>
                        <path d="M7.5 3.5C5.9442 3.54667 5.01661 3.71984 4.37477 4.36227C3.49609 5.24177 3.49609 6.6573 3.49609 9.48836L3.49609 15.9944C3.49609 18.8255 3.49609 20.241 4.37477 21.1205C5.25345 22 6.66767 22 9.49609 22L14.4961 22C17.3245 22 18.7387 22 19.6174 21.1205C20.4961 20.241 20.4961 18.8255 20.4961 15.9944V9.48836C20.4961 6.6573 20.4961 5.24177 19.6174 4.36228C18.9756 3.71984 18.048 3.54667 16.4922 3.5" stroke="#ffffff" stroke-width="1.5"></path>
                        <path d="M7.49609 3.75C7.49609 2.7835 8.2796 2 9.24609 2H14.7461C15.7126 2 16.4961 2.7835 16.4961 3.75C16.4961 4.7165 15.7126 5.5 14.7461 5.5H9.24609C8.2796 5.5 7.49609 4.7165 7.49609 3.75Z" stroke="#ffffff" stroke-width="1.5" stroke-linejoin="round"></path>
                    </svg>
                </div>
                <h1 className='text-3xl font-bold mt-4'>Edit Active Plan</h1>

                <p className="text-gray-600 mt-2 text-center">
                    Complete the form below to Edit Active Plan to your chit fund.
                    All fields marked with <span className="text-red-500">*</span> are required.
                </p>
            </div>
            <div className=' border-b-2 mt-4 '></div>

            <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 mt-4 gap-6">

                    {/* Name */}
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                            <span className='border bg-blue-100 rounded-full p-1'>


                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                                    <path d="M15.5 11C15.5 9.067 13.933 7.5 12 7.5C10.067 7.5 8.5 9.067 8.5 11C8.5 12.933 10.067 14.5 12 14.5C13.933 14.5 15.5 12.933 15.5 11Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.4827 11.3499C15.8047 11.4475 16.1462 11.5 16.5 11.5C18.433 11.5 20 9.933 20 8C20 6.067 18.433 4.5 16.5 4.5C14.6851 4.5 13.1928 5.8814 13.0173 7.65013" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.9827 7.65013C10.8072 5.8814 9.31492 4.5 7.5 4.5C5.567 4.5 4 6.067 4 8C4 9.933 5.567 11.5 7.5 11.5C7.85381 11.5 8.19535 11.4475 8.51727 11.3499" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M22 16.5C22 13.7386 19.5376 11.5 16.5 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.5 19.5C17.5 16.7386 15.0376 14.5 12 14.5C8.96243 14.5 6.5 16.7386 6.5 19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.5 11.5C4.46243 11.5 2 13.7386 2 16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </span>  Customer Name  <span className='text-lg'> *</span>
                        </label>

                        <div className="mt-2">
                            <Select
                                label="Customer Name"
                                name="customer_ids"
                                options={options}
                                onChange={handleChangeData}
                                value={options?.filter(opt => formData.customer_ids?.includes(opt.value))} // convert back for display
                                isSearchable
                                isMulti
                            />
                        </div>
                        <p className="text-red-600 text-sm mt-1">{validation.errors?.customer_ids}</p>
                    </div>

                    {/* Phone */}
                    <div>
                        <label htmlFor="phone"
                            className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                        >

                            <span className='border bg-red-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                                    <defs />
                                    <path fill="currentColor" d="M5.993,12.781 C4.748,10.564 5.068,7.706 6.954,5.82 L9.82,2.954 C12.092,0.682 15.775,0.682 18.046,2.954 C20.318,5.225 20.318,8.908 18.046,11.18 L18.007,11.219 C19.252,13.436 18.932,16.294 17.046,18.18 L14.18,21.046 C11.908,23.318 8.225,23.318 5.954,21.046 C3.682,18.775 3.682,15.092 5.954,12.82 Z M10.881,4.014 L8.014,6.881 C6.329,8.566 6.329,11.3 8.014,12.986 C9.7,14.672 12.434,14.672 14.119,12.986 L14.326,12.779 C14.619,12.486 15.094,12.486 15.387,12.779 C15.68,13.072 15.68,13.547 15.387,13.839 L15.18,14.046 C12.908,16.318 9.225,16.318 6.954,14.046 C6.937,14.029 6.92,14.012 6.904,13.995 C5.329,15.689 5.366,18.338 7.014,19.986 C8.7,21.671 11.434,21.671 13.119,19.986 L15.986,17.119 C17.671,15.434 17.671,12.7 15.986,11.014 C14.3,9.329 11.566,9.329 9.881,11.014 L9.674,11.221 C9.381,11.514 8.906,11.514 8.613,11.221 C8.32,10.928 8.32,10.453 8.613,10.161 L8.82,9.954 C11.092,7.682 14.775,7.682 17.046,9.954 C17.063,9.971 17.08,9.987 17.096,10.005 C18.671,8.312 18.634,5.662 16.986,4.014 C15.3,2.329 12.566,2.329 10.881,4.014 Z" />
                                </svg>
                            </span>
                            Plan {""}
                            <span className='text-lg'> *</span>
                        </label>
                        <div className="mt-2">
                            <select
                                id="plan_id"
                                name="plan_id"
                                value={formData.plan_id}
                                onChange={handleChange}
                                autoComplete="plan_id"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            >
                                <option value={""}>Select Plan</option>
                                {plan?.map((type) => (
                                    <option key={type.id} value={type.id}>
                                        {type.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <p className="text-red-600 text-sm mt-1">{validation.errors?.plan_id}</p>
                    </div>

                    {/* Email */}
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                            <span className='border bg-red-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#7ed321" fill="none">
                                    <path d="M8 7H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4 7H4.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8 12H8.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8 17H8.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12 12H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12 17H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span> Group
                        </label>
                        <select
                            id="group_id"
                            name="group_id"
                            value={formData.group_id}
                            onChange={handleChange}
                            autoComplete="group_id"
                            className="block w-full mt-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        >
                            <option value={""}>Select Group</option>

                            {group?.map((type) => (
                                <option key={type.id} value={type.id}>
                                    {type.group_name}
                                </option>
                            ))}
                        </select>
                        <p className="text-red-600 text-sm mt-1">{validation.errors?.group_id}</p>
                    </div>

                    {/* start_date */}
                    <div className=''>
                        <label htmlFor="start_date" className="block text-sm font-medium text-gray-700 flex items-center gap-2">



                            <span className='border bg-green-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#4a4a4a" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2988 6.57275C16.8888 6.57275 16.5488 6.23275 16.5488 5.82275V4.59836C15.7746 4.57275 14.8663 4.57275 13.7989 4.57275H11.7988C10.7314 4.57275 9.82307 4.57275 9.04883 4.59836V5.82275C9.04883 6.23275 8.70883 6.57275 8.29883 6.57275C7.88883 6.57275 7.54883 6.23275 7.54883 5.82275V4.70652C6.60369 4.82988 5.95459 5.06699 5.49883 5.52275C4.89743 6.12415 4.67673 7.06217 4.59583 8.57275H21.0019C20.9209 7.06217 20.7003 6.12415 20.0989 5.52275C19.6432 5.06698 18.994 4.82987 18.0488 4.70651V5.82275C18.0488 6.23275 17.7088 6.57275 17.2988 6.57275ZM16.5488 3.09796V2.32275C16.5488 1.91275 16.8888 1.57275 17.2988 1.57275C17.7088 1.57275 18.0488 1.91275 18.0488 2.32275V3.19485C19.4295 3.34742 20.3867 3.69064 21.1588 4.46275C22.5488 5.85275 22.5488 7.84275 22.5488 11.8228V12.8228C22.5488 13.2328 22.2088 13.5728 21.7988 13.5728C21.3888 13.5728 21.0488 13.2328 21.0488 12.8228V11.8228C21.0488 11.1845 21.0488 10.6026 21.0434 10.0728H4.55433C4.54883 10.6023 4.54883 11.1833 4.54883 11.8212V11.8222V13.8228V13.8228C4.54883 17.3824 4.54883 19.1728 5.49883 20.1227C6.44883 21.0728 8.23883 21.0728 11.7988 21.0728C12.2088 21.0728 12.5488 21.4128 12.5488 21.8228C12.5488 22.2328 12.2088 22.5728 11.7988 22.5728C7.81883 22.5728 5.82883 22.5728 4.43883 21.1828C3.04883 19.7928 3.04883 17.8028 3.04883 13.8228V11.8228C3.04883 7.85275 3.04883 5.85275 4.43883 4.46275C5.21094 3.69064 6.1682 3.34741 7.54883 3.19485V2.32275C7.54883 1.91275 7.88883 1.57275 8.29883 1.57275C8.70883 1.57275 9.04883 1.91275 9.04883 2.32275V3.09796C9.84495 3.07275 10.7532 3.07275 11.7988 3.07275H13.7988C14.8444 3.07275 15.7527 3.07275 16.5488 3.09796ZM17.7988 23.0728C15.1788 23.0728 13.0488 20.9428 13.0488 18.3228C13.0488 15.7028 15.1788 13.5728 17.7988 13.5728C20.4188 13.5728 22.5488 15.7028 22.5488 18.3228C22.5488 20.9428 20.4188 23.0728 17.7988 23.0728ZM17.7988 15.0728C16.0088 15.0728 14.5488 16.5328 14.5488 18.3228C14.5488 20.1128 16.0088 21.5728 17.7988 21.5728C19.5888 21.5728 21.0488 20.1128 21.0488 18.3228C21.0488 16.5328 19.5888 15.0728 17.7988 15.0728ZM18.7988 20.0728C18.6088 20.0728 18.4188 20.0028 18.2688 19.8528L17.2688 18.8528C17.1288 18.7128 17.0488 18.5228 17.0488 18.3228V16.3228C17.0488 15.9128 17.3888 15.5728 17.7988 15.5728C18.2088 15.5728 18.5488 15.9128 18.5488 16.3228V18.0128L19.3289 18.7928C19.6189 19.0828 19.6189 19.5628 19.3289 19.8528C19.1789 20.0028 18.9888 20.0728 18.7988 20.0728Z" fill="currentColor" />
                                </svg>
                            </span> Start Date
                        </label>
                        <input
                            id="start_date"
                            name="start_date"
                            type="date"
                            placeholder="Enter "
                            value={formData.start_date}
                            onChange={handleChange}
                            autoComplete="start_date"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                        <p className="text-red-600 text-sm mt-1">
                            {validation.errors?.start_date}
                        </p>
                    </div>

                    {/*  End Date */}
                    {/* <div>
                        <label htmlFor="zipcode" className="block text-sm font-medium text-gray-700 flex items-center gap-2">

                            <span className='border bg-gray-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#4a4a4a" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2988 6.57275C16.8888 6.57275 16.5488 6.23275 16.5488 5.82275V4.59836C15.7746 4.57275 14.8663 4.57275 13.7989 4.57275H11.7988C10.7314 4.57275 9.82307 4.57275 9.04883 4.59836V5.82275C9.04883 6.23275 8.70883 6.57275 8.29883 6.57275C7.88883 6.57275 7.54883 6.23275 7.54883 5.82275V4.70652C6.60369 4.82988 5.95459 5.06699 5.49883 5.52275C4.89743 6.12415 4.67673 7.06217 4.59583 8.57275H21.0019C20.9209 7.06217 20.7003 6.12415 20.0989 5.52275C19.6432 5.06698 18.994 4.82987 18.0488 4.70651V5.82275C18.0488 6.23275 17.7088 6.57275 17.2988 6.57275ZM16.5488 3.09796V2.32275C16.5488 1.91275 16.8888 1.57275 17.2988 1.57275C17.7088 1.57275 18.0488 1.91275 18.0488 2.32275V3.19485C19.4295 3.34742 20.3867 3.69064 21.1588 4.46275C22.5488 5.85275 22.5488 7.84275 22.5488 11.8228V12.8228C22.5488 13.2328 22.2088 13.5728 21.7988 13.5728C21.3888 13.5728 21.0488 13.2328 21.0488 12.8228V11.8228C21.0488 11.1845 21.0488 10.6026 21.0434 10.0728H4.55433C4.54883 10.6023 4.54883 11.1833 4.54883 11.8212V11.8222V13.8228V13.8228C4.54883 17.3824 4.54883 19.1728 5.49883 20.1227C6.44883 21.0728 8.23883 21.0728 11.7988 21.0728C12.2088 21.0728 12.5488 21.4128 12.5488 21.8228C12.5488 22.2328 12.2088 22.5728 11.7988 22.5728C7.81883 22.5728 5.82883 22.5728 4.43883 21.1828C3.04883 19.7928 3.04883 17.8028 3.04883 13.8228V11.8228C3.04883 7.85275 3.04883 5.85275 4.43883 4.46275C5.21094 3.69064 6.1682 3.34741 7.54883 3.19485V2.32275C7.54883 1.91275 7.88883 1.57275 8.29883 1.57275C8.70883 1.57275 9.04883 1.91275 9.04883 2.32275V3.09796C9.84495 3.07275 10.7532 3.07275 11.7988 3.07275H13.7988C14.8444 3.07275 15.7527 3.07275 16.5488 3.09796ZM17.7988 23.0728C15.1788 23.0728 13.0488 20.9428 13.0488 18.3228C13.0488 15.7028 15.1788 13.5728 17.7988 13.5728C20.4188 13.5728 22.5488 15.7028 22.5488 18.3228C22.5488 20.9428 20.4188 23.0728 17.7988 23.0728ZM17.7988 15.0728C16.0088 15.0728 14.5488 16.5328 14.5488 18.3228C14.5488 20.1128 16.0088 21.5728 17.7988 21.5728C19.5888 21.5728 21.0488 20.1128 21.0488 18.3228C21.0488 16.5328 19.5888 15.0728 17.7988 15.0728ZM18.7988 20.0728C18.6088 20.0728 18.4188 20.0028 18.2688 19.8528L17.2688 18.8528C17.1288 18.7128 17.0488 18.5228 17.0488 18.3228V16.3228C17.0488 15.9128 17.3888 15.5728 17.7988 15.5728C18.2088 15.5728 18.5488 15.9128 18.5488 16.3228V18.0128L19.3289 18.7928C19.6189 19.0828 19.6189 19.5628 19.3289 19.8528C19.1789 20.0028 18.9888 20.0728 18.7988 20.0728Z" fill="currentColor" />
                                </svg>
                            </span>
                            End Date
                        </label>
                        <input
                            id="end_date"
                            name="end_date"
                            type="date"
                            placeholder="Group Name"
                            value={formData.end_date}
                            onChange={handleChange}
                            autoComplete="amount"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                        <p className="text-red-600 text-sm mt-1">{validation.errors?.end_date}</p>
                    </div> */}

                    {/* Status Upload */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 flex items-center gap-2 mb-1">
                            {/* <ArrowUpTrayIcon className="w-5 h-5 text-gray-500" /> */}

                            <span className='border bg-blue-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#4a4a4a" fill="none">
                                    <defs />
                                    <path fill="currentColor" d="M8.502,18.25 C8.502,18.25 8.495,18.25 8.492,18.25 C8.226,18.246 7.982,18.103 7.851,17.872 C6.173,14.936 5.015,14.771 5.002,14.77 C5.002,14.77 4.744,14.83 4.479,14.551 C4.213,14.271 4.252,13.953 4.252,13.953 C4.252,13.953 4.268,13.664 4.479,13.457 C4.69,13.25 5.002,13.25 5.002,13.25 C5.292,13.25 6.703,13.4 8.511,16.089 C10.148,13.595 14.575,7.343 18.741,5.797 C19.129,5.653 19.561,5.851 19.705,6.239 C19.849,6.627 19.651,7.059 19.263,7.203 C14.625,8.924 9.198,17.799 9.143,17.889 C9.007,18.113 8.764,18.25 8.502,18.25 Z" />
                                </svg>
                            </span>
                            Status
                        </label>
                        <select
                            id="status"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                            autoComplete="status"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        >
                            <option value={""}>Select Status</option>
                            <option value="active">active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                        <p className="text-red-600 text-sm mt-1">{validation.errors?.status}</p>
                    </div>
                </div>

                {/* Submit Button */}
                <div className="mt-6 text-right">
                    <button
                        type="submit"
                        className="inline-flex items-center gap-2 px-6 py-2 bg-[#0f172a] text-white text-sm font-medium rounded-md shadow hover:bg-teal-900 transition-all"
                    >
                        Save
                    </button>
                </div>
            </form>

        </div>
    )
}

export default ActivePlanEdit
